module.exports = __webpack_public_path__ + "ea6ba2e0526f1f5737fadbf674dbb64c.svg";